import moment from 'moment';

const validateDate = (date, format = 'DD/MM/YYYY') => moment(date, format, true).isValid();

export default {
  getMessage() {
    return 'Data inválida';
  },
  validate(val) {
    return validateDate(val, 'DD-MM-YYYY');
  },
};



// WEBPACK FOOTER //
// ./src/common/validations/time.js